import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApirequestService} from '../../../../services/apirequest/apirequest.service';
import {ApiurlsService} from '../../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../../services/utilities/utilities.services';
import {Router} from '@angular/router';
import {ToastsManager} from 'ng2-toastr';
import {FormBuilder} from '@angular/forms';
import {OrderPipe} from 'ngx-order-pipe';
import {transition, trigger, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';

@Component({
  selector: 'hybse-admin-vconfig-list',
  templateUrl: './vconfig-list.component.html',
  styleUrls: ['./vconfig-list.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class VconfigListComponent implements OnInit {
  public showLoader: boolean = true;
  public vconfigList: any = [];
  public paginatorList: any = [];
  public paginatorCount: number;
  fadeInDown: any;
  public errorMessage: string;
  public listTitle = 'All Voucher Configuration';
  public count: number;
  public limit: number = 50;
  public offset: number = 0;
  public filterType: number;

  // sorting
  reverse = false;
  order = 'createdat';
  sortedCollection: any = [];

  constructor(public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcs: ViewContainerRef,
              private orderPipe: OrderPipe) {
      this.toastr.setRootViewContainerRef(vcs);
  }

  getVoucherConfigList() {
    const data = {
      offset: this.offset,
      limit: this.limit
    };

    this.vconfigList = [];

    this._api.fetchApiData(this._urls.vconfigListUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const errRes = res.error;

        if (response) {
          this.vconfigList = response.voucherConfigList;
          this.count = response.count;
        } else {
          this.errorMessage = errRes['errorDescription'];
        }
      },
      error => {
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    if (value === 'createdat') {
      this.showLoader = true;
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getVoucherConfigList();
    }
    this.order = value;
  }

  pagination(e) {
    this.offset = (e.pageIndex * 50);
    this.getVoucherConfigList();
  }

  ngOnInit() {
    this.getVoucherConfigList();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/voucher-config/vconfig-list/vconfig-list.component.ts